import { faCircleNotch, faWifi } from "@fortawesome/free-solid-svg-icons";
import { faWifiSlash } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRealtimeConnection } from "@traas/lib/src/realtime/RealtimeConnectionContext";
import { FC } from "react";

export const RealtimeConnectionStatusBanner: FC = () => {
  const conn = useRealtimeConnection();
  const containerStyleVariant = {
    online: "",
    offline: "text-amber-900 bg-amber-100 border-amber-400",
    connecting: "text-slate-900 bg-slate-100 border-slate-300",
  }[conn.status];
  const headerVariant = {
    online: "Verbonden",
    offline: "Verbinding verbroken",
    connecting: "Verbinden met server...",
  }[conn.status];
  const textVariant = {
    online: "verbinding actief",
    offline: "geen live updates beschikbaar",
    connecting: "nog geen live updates beschikbaar",
  }[conn.status];
  const iconVariant = {
    online: <FontAwesomeIcon className={"text-sm text-blue-600"} icon={faWifi} />,
    offline: <FontAwesomeIcon className={"text-sm text-amber-600"} icon={faWifiSlash} />,
    connecting: <FontAwesomeIcon className={"text-sm text-slate-600"} icon={faCircleNotch} spin={true} />,
  }[conn.status];

  if (conn.status === "online") {
    return null;
  }
  return (
    <div
      className={`fixed z-90 bottom-8 left-1/2 -translate-x-1/2 h-8 px-3 flex items-center rounded-lg shadow-lg border ${containerStyleVariant}`}
    >
      {iconVariant}
      <div className={"mx-3 font-medium"}>{headerVariant}</div>
      <div className={"text-xs opacity-75"}>{textVariant}</div>
    </div>
  );
};
